import React from "react";

const SentenceTrendsEditButton = ({
  label,
  isEdited,
  onClick,
  disabled,
  className = "",
}) => (
  <button
    type="button"
    className={`sentence-trends-edit-btn${isEdited ? " is-edited" : ""}${
      className ? ` ${className}` : ""
    }`}
    onClick={onClick}
    disabled={disabled}
    title={isEdited ? "This section has customized text" : undefined}
  >
    {label}
    {isEdited ? <span className="edited-badge">Edited</span> : null}
  </button>
);

export default SentenceTrendsEditButton;
